import { FC } from 'react';

import CurrentLocationXs from '@/assets/icons/CurrentLocationXs';
import { LocatieVoorEenheden } from '@/types/LocatieVoorEenheden';

import { titleVoorLocatie } from '../defect';

import styles from './DefectHuidigeLocatie.module.css';
type DefectHuidigeLocatieProps = {
  huidigeLocatie: LocatieVoorEenheden | undefined;
};
const DefectHuidigeLocatie: FC<DefectHuidigeLocatieProps> = ({ huidigeLocatie = undefined }) => {
  return (
    <>
      {huidigeLocatie ? (
        <div
          data-testid={`defect_locatie_${huidigeLocatie.eenheidNummer}`}
          className={styles.locatieStyle}
          title={titleVoorLocatie(huidigeLocatie)}
        >
          {huidigeLocatie.dienstregelpunt}
          {!huidigeLocatie.stilstaande && <CurrentLocationXs className={styles.locatieIconStyle} aria-hidden='true' />}
        </div>
      ) : null}
    </>
  );
};
export default DefectHuidigeLocatie;
